'use client'

export default function StyleProvider() {
  return (
    <style jsx global>{`
      @keyframes pulse-slow {
        0%, 100% { opacity: 0.7; }
        50% { opacity: 0.3; }
      }
      .animate-pulse-slow {
        animation: pulse-slow 4s cubic-bezier(0.4, 0, 0.6, 1) infinite;
      }
    `}</style>
  )
} 